import { memo } from 'react';
import { Text, useTheme } from '@Sage/hoi-poi-ui';

import './MarketingStatusReadOnlyChip.scss';

const MarketingStatusReadOnlyChip = memo(({ option }) => {
    const theme = useTheme();
    const bgColor = option?.bgColor ?? theme.colors.background.utility025;
    const borderColor = option?.borderColor ?? theme.colors.actionMinor[200];
    const textColor = option?.textColor ?? theme.colors.actionMinor[600];

    return (
        <span
            className="fm-marketing-status-readonly-chip"
            style={{ backgroundColor: bgColor, borderColor }}
        >
            <Text
                type="badges"
                className="fm-marketing-status-readonly-chip__label"
                color={textColor}
            >
                {option?.label ?? ''}
            </Text>
        </span>
    );
});

MarketingStatusReadOnlyChip.displayName = 'MarketingStatusReadOnlyChip';

export default MarketingStatusReadOnlyChip;
